import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import PriceModifiers from 'software_products/components/PriceModifiers';
import FormalQuoteBanner from 'formal_quote/inline_formal_quote/components/FormalQuoteBanner';
import store from 'software_products/redux/store';

const renderSubscriptionProduct = (CartComponent) => {
  document.addEventListener('DOMContentLoaded', () => {
    const appContainer = document.getElementById('price-modifiers');
    const cartContainer = document.getElementById('cart');
    const formalQuoteContainer = document.getElementById('formal-quote-banner');

    if (appContainer == null || cartContainer == null) {
      return;
    }

    render(
      <Provider store={store}>
        <PriceModifiers />
      </Provider>,
      appContainer,
    );

    render(
      <Provider store={store}>
        <CartComponent />
      </Provider>,
      cartContainer,
    );

    if (formalQuoteContainer) {
      render(
        <Provider store={store}>
          <FormalQuoteBanner />
        </Provider>,
        formalQuoteContainer,
      );
    }
  });
};

export default renderSubscriptionProduct;
